module.exports = __webpack_public_path__ + "media/images/flags/mn-5e4557f7ed743f19592c0f3d5424ad8f.svg";